// ===============================
// Core React & Router Imports
// ===============================
import React, { useEffect } from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import { withRouter } from "react-router";

// ===============================
// SEO
// ===============================
import { Helmet } from "react-helmet";

// ===============================
// Survey Link Pages
// ===============================
import MainPage from "../pages/Surveylink/MainPage";
import TeenCareerPage from "../pages/Surveylink/TeenCareerPage";
import ExpertBooked from "../pages/Surveylink/QuestionV6/Summary/Summary/ExpertsSummary/ExpertBooked";

// ===============================
// Authentication Pages
// ===============================
import Login from "../pages/Login/Login";
import Ssologin from "../pages/Ssologin/Ssologin";
import AssessmentLogin from "../pages/Login/AssessmentLogin";
import AssessmentLoginByOTP from "../pages/Login/AssessmentLoginByOTP";
import SignIn from "../pages/Assessment/Login/SignIn";

// ===============================
// Assessment Core Pages
// ===============================
import Registration from "../pages/Assessment/Registration/Registration";
import SurveyLogin from "../pages/Assessment/Survey/SurveyLogin";

// ===============================
// Home & Landing Pages
// ===============================
import Home from "../pages/Assessment/Home/Home";
import Homeold from "../pages/Assessment/Home/Homeold";
import Employer from "../pages/Assessment/Home/Employer";
import Individual from "../pages/Assessment/Home/Individual";

// ===============================
// Teen Assessment Pages
// ===============================
import TeenTalent from "../pages/Assessment/TeenTalent/TeenTalent";
import TeenDiscoverYourself from "../pages/Assessment/TeenDiscoverYourself/TeenDiscoverYourself";
import TeenCareerLibraries from "../pages/Assessment/TeenCareerLibraries/TeenCareerLibraries";
import TeenPersonalizedReport from "../pages/Assessment/TeenPersonalizedReport/TeenPersonalizedReport";
import TeenCareerFitment from "../pages/Assessment/TeenCareerFitment/TeenCareerFitment";

// ===============================
// Product & Order Flow
// ===============================
import Package from "../pages/Assessment/Package/Package";
import ProductDetails from "../pages/Assessment/ProductDetails/ProductDetails";
import Temp from "../pages/Assessment/ProductDetails/Temp";
import Orders from "../pages/Assessment/Orders/Orders";
import OrderReview from "../pages/Assessment/Orders/OrderReview";
import Payment from "../pages/Assessment/Payment/Payment";
import Cancelled from "../pages/Assessment/Payment/Cancelled";

// ===============================
// Cart & Orders
// ===============================
import Mycart from "../pages/Assessment/MyCart/Mycart";
import MyOrders from "../pages/Assessment/MyOrders/MyOrders.js";
import EditProfile from "../pages/Assessment/MyOrders/EditProfile";
import User from "../pages/Assessment/MyOrders/User";
import AssessmentProducts from "../pages/Assessment/MyOrders/AssessmentProducts";
import AssessmentProductsNew from "../pages/Assessment/MyOrders/AssessmentProductsNew";
// import MyTeams from "../pages/Assessment/MyOrders/MyTeams";

// ===============================
// Informational Pages
// ===============================
import DomainTheme from "../pages/Assessment/DomainTheme/DomainTheme";
import ContactUs from "../pages/Assessment/ContactUs/ContactUs";
import StrengthWorks from "../pages/Assessment/StrengthWorks/StrengthWorks";
import Term from "../pages/Assessment/Term/Term";
import Privacy from "../pages/Assessment/PrivacyandPolicy/Privacy";
import Aboutus from "../pages/Assessment/Aboutus/Aboutus";

// ===============================
// Blog & Research
// ===============================
import Blog from "../pages/Assessment/Blog/Blog";
import BlogDeatil from "../pages/Assessment/Blog/BlogDeatails";
import ResearchPaper from "../pages/Assessment/ResearchPaper/ResearchPaper";
import ExploreResearch from "../pages/Assessment/ExploreResearch/ExploreResearch";
import ResearchInsights from "../pages/Assessment/ResearchInsights/ResearchInsights";

// ===============================
// Utilities & Misc
// ===============================
import ImpactCoach from "../pages/Assessment/ImpactCoach/ImpactCoach";
import Emailer from "../pages/Assessment/Emailer/Emailer";
import Test from "../pages/Test";
import NotFoundPage from "../pages/NotFoundPage";

// ===============================
// USER Dashboard
// ===============================
import CoachSignIn from "../pages/Assessment/Login/CoachSignIn";


// ===============================
// School Assessment Layout
// ===============================
// import AssessmentTalentWheel from "../pages/Surveylink/Component/AssessmentReport/Components/AssessmentTalentWheel";


import StudentSignIn from "../pages/Assessment/StudentLogin/StudentSignIn";
import StudentRegistration from "../pages/Assessment/StudentLogin/StudentRegistration";
import StudentDashboard from "../pages/Assessment/StudentDashboard/StudentDashboard";
import StudentSchool from "../pages/Assessment/StudentDashboard/StudentSchool";
import StudentAssessmentCode from "../pages/Assessment/StudentDashboard/StudentAssessmentCode";
import StudentAssessmentCodeList from "../pages/Assessment/StudentDashboard/StudentAssessmentCodeList";
import StudentReports from "../pages/Assessment/StudentDashboard/StudentReports";
import StudentProfile from "../pages/Assessment/StudentDashboard/StudentProfile";
import StudentKnowledgeHub from "../pages/Assessment/StudentDashboard/StudentKnowledgeHub";
import StudentList from "../pages/Assessment/StudentDashboard/StudentList";
import TeenCareerLibrariesDetails from "../pages/Assessment/TeenCareerLibrariesDetails/TeenCareerLibrariesDetails.js";
import CampaignList from "../pages/Assessment/StudentDashboard/Campaign/CampaignList";
// import CampaignAnalytics from "../pages/Assessment/StudentDashboard/Campaign/CampaignAnalytics";
// import StudentSignIn from "../pages/Assessment/StudentLogin/StudentSignIn";
// import StudentRegistration from "../pages/Assessment/StudentLogin/StudentRegistration";
// import StudentDashboard from "../pages/Assessment/StudentDashboard/StudentDashboard";
// import StudentSchool from "../pages/Assessment/StudentDashboard/StudentSchool";
// import StudentAssessmentCode from "../pages/Assessment/StudentDashboard/StudentAssessmentCode";
// import StudentAssessmentCodeList from "../pages/Assessment/StudentDashboard/StudentAssessmentCodeList";
// import StudentReports from "../pages/Assessment/StudentDashboard/StudentReports";
// import StudentProfile from "../pages/Assessment/StudentDashboard/StudentProfile";
// import StudentKnowledgeHub from "../pages/Assessment/StudentDashboard/StudentKnowledgeHub";
// import StudentList from "../pages/Assessment/StudentDashboard/StudentList";
// import TeenCareerLibrariesDetails from "../pages/Assessment/TeenCareerLibrariesDetails/TeenCareerLibrariesDetails.js";

// import Campaigns from "../pages/Assessment/Campaign/Campaigns";
// import CampaignAnalytics from "../pages/Assessment/Campaign/CampaignAnalytics";
// import AdminPanel from "../pages/AdminPanel/AdminPanel/AdminPanel";
// import LoginAdmin from "../pages/AdminPanel/LoginAdmin/LoginAdmin";
// import LoginAdmin from "../pages/Assessment/Login/LoginAdmin";

import AssessmentOverview from "../pages/AssessmentOverview/AssessmentOverview";
import ChatDashboard from "../pages/ChatBot/ChatDashboard/ChatDashboard";
import AssessmentPage from "../pages/Surveylink/AssessmentPage";

import Overview from "../pages/AdminPanel/Overview/Overview";

import MyResults from "../pages/AdminPanel/MyResults/MyResults";
import OverviewNew from "../pages/AdminPanel/OverviewNew/OverviewNew";
import AssessmentCodeList from "../pages/AdminPanel/OverviewNew/AssessmentCodeList";
import MyUsers from "../pages/AdminPanel/MyUsers/MyUsers";
import MyTeam from "../pages/AdminPanel/MyTeam/MyTeam";
import MyTeamDetails from "../pages/AdminPanel/MyTeam/MyTeamDetails";
import MyCampaigns from "../pages/AdminPanel/MyCampaigns/MyCampaigns";
import Account from "../pages/AdminPanel/Account/Account";
import MyCampaignResponse from "../pages/AdminPanel/MyTeam/MyCampaignResponse";
import Settings from "../pages/AdminPanel/Settings/Settings";
import AssessmentCodes from "../pages/AdminPanel/Settings/AssessmentCodes";
import Report from "../pages/AdminPanel/Report/Report";
import SelfDashbaord from "../pages/AdminPanel/SelfDashbaord/SelfDashbaord";
import SummaryDashboard from "../pages/AdminPanel/Overview/SummaryDashboard";
import MyReport from "../pages/AdminPanel/MyReport/MyReport";
import MyChatBot from "../pages/AdminPanel/MyChatBot/MyChatBot";

// ===============================
// USER PANEL
// ===============================

import UserOverview from "../pages/UserPanel/Overview/Overview";
import UserOverviewList from "../pages/UserPanel/Overview/UserOverviewList";
import AssessmentByCode from "../pages/Surveylink/AssessmentByCode";
// import WelcomeReport from "../pages/UserPanel/MyReport/FlowProfileReport/WelcomeReport";
import MileProfileReport from "../pages/UserPanel/MyReport/MileProfileReport/MileProfileReport";

import EnergyProfileReport from "../pages/UserPanel/MyReport/EnergyProfileReport/EnergyProfileReport";


// ===============================
// Welcome Page Routes
// ===============================

import WelcomeProfile from "../pages/UserPanel/Overview/WelcomeProfile";
import WelcomeSurvey from "../pages/UserPanel/Overview/WelcomeSurvey";
// import WelcomeReport from "../pages/UserPanel/WelcomeReport";




// ===============================
// USER PANEL ( PROFILE )
// ===============================

import UserLogin from "../pages/UserPanel/UserLogin";
import FlowProfileReport from "../pages/UserPanel/MyReport/FlowProfileReport/FlowProfileReport";
import AssessmentLoginByCode from "../pages/Login/AssessmentLoginByCode";
import MyCodes from "../pages/AdminPanel/MyCodes/MyCodes";
import MyVideos from "../pages/AdminPanel/MyReport/MyVideos";



// ===============================
// Main App Component
// ===============================
export default function App() {

  // Scroll to top on initial load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // ===============================
  // Schema Markup for SEO
  // ===============================
  const TalentPlusSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://www.talentplus.com/",
    name: "Consultant in Mumbai, Maharashtra",
    image: "https://www.talentplus.com/svg/talentplus-logo.svg",
    url: "https://www.talentplus.com/",
    review: { "@type": "Review" },
    reviewRating: {
      "@type": "Rating",
      ratingValue: "4.9",
      bestRating: "5",
    },
    address: {
      "@type": "PostalAddress",
      streetAddress: "1&2, GREEN HILL-B, 303, 25/A, near NNP, Goregaon ",
      addressLocality: "Mumbai,",
      addressRegion: "Maharashtra",
      postalCode: "400065 ,",
      addressCountry: "IN",
    },
    offers: {
      "@type": "Offer",
      price: "20-25",
      priceCurrency: "USD",
      availability: "https://schema.org/InStock",
    },
    author: {
      "@type": "Person",
      name: "talentplus",
    },
  };

  return (
    <div className="font-fma">
      {/* SEO Schema */}
      <Helmet>
        <script type="application/ld+json" defer>
          {JSON.stringify(TalentPlusSchema)}
        </script>
      </Helmet>

      {/* Router */}
      <HashRouter>
        <Switch>

          {/* Default Redirect */}
          <Route exact path="/" render={() => <Redirect to="/assessment/home" />} />

          {/* Home Routes */}
          <Route path="/assessment/home" component={withRouter(Home)} />
          <Route path="/assessment/homeold" component={withRouter(Homeold)} />
          <Route path="/assessment/employer" component={withRouter(Employer)} />
          <Route path="/assessment/individual" component={withRouter(Individual)} />

          {/* Authentication */}
          <Route path="/login/:id" component={withRouter(Login)} />
          <Route path="/ssologin" component={withRouter(Ssologin)} />
          <Route path="/assessment/login" component={withRouter(AssessmentLogin)} />
          <Route path="/assessment/signin" component={withRouter(AssessmentLoginByOTP)} />

          {/* <Route path="/assessment/sign-in" component={withRouter(SignIn)} /> */}
          <Route path="/assessment/sign-up" component={withRouter(Registration)} />

          {/* Survey Links */}
          <Route path="/v2/:id" component={withRouter(MainPage)} />
          <Route path="/assessment/surveylogin" component={withRouter(SurveyLogin)} />
          <Route path="/assessment/career" component={withRouter(TeenCareerPage)} />

          {/* Teen Assessment */}
          <Route path="/assessment/teen-talent" component={withRouter(TeenTalent)} />
          <Route path="/assessment/teen-discover-yourself" component={withRouter(TeenDiscoverYourself)} />
          <Route path="/assessment/teen-career-libraries" component={withRouter(TeenCareerLibraries)} />
          <Route path="/assessment/teen-personalized-report" component={withRouter(TeenPersonalizedReport)} />
          <Route path="/assessment/teen-career-fitment-analysis" component={withRouter(TeenCareerFitment)} />

          {/* Products & Orders */}
          <Route path="/assessment/products" component={withRouter(Package)} />
          <Route path="/assessment/productdetails/:id1/:id2" component={withRouter(ProductDetails)} />
          <Route path="/assessment/temp" component={withRouter(Temp)} />
          <Route path="/assessment/orders" component={withRouter(Orders)} />
          <Route path="/assessment/order-review/:id" component={withRouter(OrderReview)} />
          <Route path="/assessment/order-complete/:id" component={withRouter(Payment)} />
          <Route path="/assessment/order-cancelled" component={withRouter(Cancelled)} />

          {/* Cart & Account */}
          <Route path="/assessment/my-cart" component={withRouter(Mycart)} />
          <Route path="/assessment/my-orders" component={withRouter(MyOrders)} />
          <Route path="/assessment/profile-summary" component={withRouter(EditProfile)} />
          <Route path="/assessment/user" component={withRouter(User)} />
          <Route path="/assessment/assessment-code" component={withRouter(AssessmentProducts)} />
          <Route path="/assessment/assessment-code-new" component={withRouter(AssessmentProductsNew)} />

          {/* Info Pages */}
          <Route path="/assessment/the-4-domains-and-22-themes" component={withRouter(DomainTheme)} />
          <Route path="/assessment/contact-us" component={withRouter(ContactUs)} />
          <Route path="/assessment/how-talentplus-strength-works" component={withRouter(StrengthWorks)} />
          <Route path="/assessment/terms-and-conditions" component={withRouter(Term)} />
          <Route path="/assessment/privacy-policy" component={withRouter(Privacy)} />
          <Route path="/assessment/about-us" component={withRouter(Aboutus)} />

          {/* Blog & Research */}
          <Route path="/assessment/blog" component={withRouter(Blog)} />
          <Route path="/assessment/blogdetails/:id" component={withRouter(BlogDeatil)} />
          <Route path="/assessment/research-paper" component={withRouter(ResearchPaper)} />
          <Route path="/assessment/research-insights" component={withRouter(ExploreResearch)} />
          <Route path="/assessment/talentweave" component={withRouter(ResearchInsights)} />

          {/* Misc */}
          <Route path="/assessment/impact-coach" component={withRouter(ImpactCoach)} />
          <Route path="/assessment/emailer" component={withRouter(Emailer)} />
          <Route path="/assessment/test" component={withRouter(Test)} />
          <Route path="/assessment/expert-booked/:id" component={withRouter(ExpertBooked)} />
          <Route path="/assessment/student-sign-in" component={withRouter(StudentSignIn)} />


          {/* User Dashboard */}
          {/* <Route path="/assessment/sign-in" component={withRouter(LoginAdmin)} /> */}
          <Route path="/assessment/sign-up" component={withRouter(Registration)} />
          {/* <Route path="/assessment/loginadmin" component={withRouter(LoginAdmin)} /> */}

          {/* <Route path="/assessment/admindashboard" component={withRouter(AdminPanel)} /> */}



          {/* School Assessment */}
          {/* <Route path="/assessment/wheel" component={withRouter(AssessmentTalentWheel)} /> */}
          {/* <Route path="/assessment/teen-career-guidance" component={withRouter(TeenCareerGuidance)} /> */}
          {/* <Route path="/assessment/teen-career-libraries-deatils" component={withRouter(TeenCareerLibrariesDetails)} /> */}
          {/* <Route path="/assessment/student-sign-in" component={withRouter(StudentSignIn)} />
          <Route path="/assessment/student-sign-up" component={withRouter(StudentRegistration)} />
          <Route path="/assessment/student-dashboard" component={withRouter(StudentDashboard)} />
          <Route path="/assessment/student-school" component={withRouter(StudentSchool)} />
          <Route path="/assessment/student-list/:id" component={withRouter(StudentList)} />
          
          <Route path="/assessment/myteam" component={withRouter(MyTeams)} />

          <Route path="/assessment/campaigns" component={withRouter(Campaigns)} />
          <Route path="/assessment/campaign/:id" component={withRouter(CampaignList)} />
          <Route path="/assessment/analytics/:id/:idc" component={withRouter(CampaignAnalytics)} />

          <Route path="/assessment/student-assessment-code" component={withRouter(StudentAssessmentCode)} />
          <Route path="/assessment/student-assessment-code-list" component={withRouter(StudentAssessmentCodeList)} />
          <Route path="/assessment/student-reports" component={withRouter(StudentReports)} />
          <Route path="/assessment/student-profile" component={withRouter(StudentProfile)} />
          <Route path="/assessment/student-knowledge-hub" component={withRouter(StudentKnowledgeHub)} />

          {/* Error */}
          <Route path="/notfound" component={withRouter(NotFoundPage)} />


          {/* Welcome Screen all  */}

          <Route path="/assessment/sign-in" component={withRouter(UserLogin)} />
          <Route path="/assessment/welcomesurvey" component={withRouter(WelcomeSurvey)} />
          <Route path="/assessment/welcomeprofile" component={withRouter(WelcomeProfile)} />
          {/* <Route path="/welcomereport" component={withRouter(WelcomeReport)} /> */}

          <Route path="/assessment/survey" component={withRouter(AssessmentPage)} />
          <Route path="/assessment/summary/:id" component={AssessmentOverview} />
          <Route path="/assessment/chatdashboard" component={withRouter(ChatDashboard)} />

          <Route path="/assessment/myusers" component={withRouter(MyUsers)} />
          <Route path="/assessment/myteams" component={withRouter(MyTeam)} />
          <Route path="/assessment/myteamdetails/:id" component={withRouter(MyTeamDetails)} />
          <Route path="/assessment/mycampaigns" component={withRouter(MyCampaigns)} />
          <Route path="/assessment/mycampaigns" component={withRouter(MileProfileReport)} />

          <Route path="/assessment/overview-new" component={withRouter(OverviewNew)} />
          <Route path="/assessment/assessmentcode-list" component={withRouter(AssessmentCodeList)} />

          <Route path="/assessment/myaccount" component={withRouter(Account)} />
          {/* <Route path="/assessment/responses/:id" component={withRouter(MyCampaignResponse)} /> */}
          <Route path="/assessment/settings" component={withRouter(Settings)} />
          <Route path="/assessment/assessment-codes" component={withRouter(AssessmentCodes)} />
          <Route path="/assessment/report" component={withRouter(Report)} />
          <Route path="/assessment/self" component={withRouter(SelfDashbaord)} />
          <Route path="/assessment/dashboard" component={withRouter(SummaryDashboard)} />
          <Route path="/assessment/myreport" component={withRouter(MyReport)} />
          <Route path="/assessment/mychatbot" component={withRouter(MyChatBot)} />

          <Route path="/assessment/useroverview" component={withRouter(UserOverview)} />
          <Route path="/assessment/useroverview-list" component={withRouter(UserOverviewList)} />
          <Route path="/assessment/questions/:id" component={withRouter(AssessmentByCode)} />

          <Route path="/assessment/focusprofilereport/:id/:idx" component={withRouter(FlowProfileReport)} />
          <Route path="/assessment/energyprofilereport/:id/:idx" component={withRouter(EnergyProfileReport)} />
          <Route path="/assessment/mileprofilereport/:id/:idx" component={withRouter(MileProfileReport)} />

          <Route path="/assessment/useroverview" component={withRouter(UserOverview)} />

          <Route path="/assessment/code" component={withRouter(AssessmentLoginByCode)} />
          <Route path="/assessment/responses/:id" component={withRouter(MyCampaignResponse)} />
          <Route path="/assessment/myresults" component={withRouter(MyResults)} />
          <Route path="/assessment/overview" component={withRouter(Overview)} />
          <Route path="/assessment/mycodes/:id" component={withRouter(MyCodes)} />
          <Route path="/assessment/myvideos" component={withRouter(MyVideos)} />


        </Switch>
      </HashRouter>
    </div>
  );
}
